export default __webpack_public_path__ + "static/media/image.smart-edge.12572421.png";